<template>
  <div v-if="showModal" class="modal__overlay opened" id="modal__to__reg">
    <div class="modal__alert">
      <div class="modal__header">
        <h3 class="modal__title">Внимание!</h3>
        <span class="modal__close" @click="closeModal"><svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
      </div>
      <div class="modal__content">
        Для создания заявления вам необходимо полностью заполнить свой профиль
      </div>
      <div class="space__between">
        <button type="button" class="button button--cancel" @click="closeModal">Отмена</button>
        <router-link :to="{name: 'ApplicantProfileDetail'}" @click="closeModal"
                     class="button button__icon--right">Заполнить профиль
          <svg viewBox="0 0 24 24" width="24" height="24" class="icon"><use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use></svg>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showModal: false
    }
  },
  beforeMount() {
    this.$emitter.on('open-fill-profile-warning-modal', () => {
      this.openModal()
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-fill-profile-warning-modal')
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
  }
}
</script>